import Keycloak from 'keycloak-js';

const keycloakInstance = new Keycloak({
  url: `${process.env.REACT_APP_KEYCLOAK_LOGIN_URL}/auth`,
  realm: process.env.REACT_APP_KEYCLOAK_REALM || '',
  clientId: process.env.REACT_APP_KEYCLOAK_CLIENTID || '',
});

export default keycloakInstance;
